function notifyModal(message, type) {
    var modal = document.getElementById("modal-notify");
    var textContent = modal.querySelector(".form-info");
    textContent.innerHTML = message;
    MicroModal.show("modal-notify");
    setTimeout(function () {
        MicroModal.close("modal-notify");
    }, 4000);
}

export default notifyModal;
